export default __webpack_public_path__ + "static/media/geo.432eda92.svg";